import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { trainSchedAction } from "src/store/Slices/Administrator/TrainSchedSlice";
import AddEditTrainSchedModal from "./Modals/AddEditTrainSchedModal";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const TrainSched = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Расписание" },
        {
            label: "По сотруднику",
            value: 2,
            index: "employ",
            title: "Сотрудник",
        },
        {
            label: "По дню недели",
            value: 3,
            index: "dayOfWeek",
            title: "День недели",
        },
        {
            label: "По времени работы от",
            value: 4,
            index: "timeFrom",
            title: "Время работы от",
        },
        {
            label: "По времени работы до",
            value: 5,
            index: "timeTo",
            title: "Время работы до",
        },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [trainSchedInfo, setTrainSchedInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const trainSchedList = useSelector(
        (state) => state.TrainSchedSlice.trainSchedList
    );
    const trainSchedListLoading = useSelector(
        (state) => state.TrainSchedSlice.trainSchedListLoading
    );

    const onClickDelete = () => {
        dispatch(
            trainSchedAction({
                flag: "delete",
                value: { id: trainSchedInfo.id },
            })
        ).then(() => {
            dispatch(trainSchedAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["Id.From"] = values[index][0];
                        formattedItems["Id.To"] = values[index][1];
                    } else if (key === "price") {
                        formattedItems["price.From"] = values[index][0];
                        formattedItems["price.To"] = values[index][1];
                    } else if (key === "employ") {
                        formattedItems["employId"] = values[index][0];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            trainSchedAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setTrainSchedInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            trainSchedAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            trainSchedAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(trainSchedAction({ flag: "get" }));
    }, []);

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(
            trainSchedAction({ flag: "get", value: { isDeleted: value } })
        );
        setPage(1);
        setPageSize(20);
    };

    return (
        <>
            <AddEditTrainSchedModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                trainSchedInfo={trainSchedInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={trainSchedListLoading}
                    onClickRowOne={(record) => {
                        setTrainSchedInfo(record);
                    }}
                    columns={trainSchedList}
                    rows={trainSchedList?.data?.value?.rows}
                    total={trainSchedList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    items={items}
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={trainSchedList}
                    elementsListLoading={trainSchedListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    filterOptionsArr={filterOptionsArr}
                    clickOnAction={clickOnAction}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default TrainSched;
